import { StyleSheet, View } from "react-native";

import Text from "@components/CustomText";

import React from "react";
import color from "@constants/color";
import OrderStatus from "@assets/svg/OrderStatus";

const RtoFooter = ({ footer }) => {
  return (
    <View style={styles.footer}>
      <OrderStatus
        orderStatus="RequestApproved"
        orderStatusColor={footer?.title_color}
      />
      <View style={{ marginLeft: 8 }}>
        {footer?.title ? (
          <Text
            variant="body_text_4"
            style={{
              color: footer?.title_color,
            }}
          >
            {footer?.title}
          </Text>
        ) : null}
        {footer?.subtitle ? (
          <Text
            variant="body_text_3"
            style={{
              color: color.mediumBlack,
            }}
          >
            {footer?.subtitle}
          </Text>
        ) : null}
        {footer?.body ? (
          <Text
            variant="caption_2"
            style={{
              color: color.mediumBlacklightBlack,
            }}
          >
            {footer?.body}
          </Text>
        ) : null}
      </View>
    </View>
  );
};

export default RtoFooter;

const styles = StyleSheet.create({
  footer: {
    flexDirection: "row",
    backgroundColor: "rgba(66, 116, 234, 0.1)",
    padding: 16,
    alignItems: "flex-start",
  },
});
